/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InStoreGiftCardsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type InStoreGiftCardsQuery = {
  readonly __typename?: 'Query';
  readonly inStorePaymentMethods: ReadonlyArray<{
    readonly __typename?: 'Credit';
    readonly id: string;
    readonly title: string;
    readonly remainingAmount: number;
  }>;
};

export const inStoreGiftCardsQueryMock: ExecutionResult<InStoreGiftCardsQuery> =
  {
    data: {
      inStorePaymentMethods: [
        {
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          title: 'Hello World',
          remainingAmount: 64.46,
        },
        {
          id: 'a7a7163b-a7ed-4a96-a8a1-85e3da00a9a4',
          title: 'Hello World',
          remainingAmount: -1.97,
        },
        {
          id: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
          title: 'Hello World',
          remainingAmount: -17.73,
        },
      ],
    },
  };

export const InStoreGiftCardsDocument = gql`
  query InStoreGiftCards {
    inStorePaymentMethods {
      id
      title
      remainingAmount
    }
  }
`;

export function useInStoreGiftCardsQuery(
  options?: Omit<Urql.UseQueryArgs<InStoreGiftCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<InStoreGiftCardsQuery, InStoreGiftCardsQueryVariables>({
    query: InStoreGiftCardsDocument,
    ...options,
  });
}
